import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X, Plus } from "lucide-react";

export function TagsField({ value, onChange, optionKey, testid }) {
  const tags = Array.isArray(value) ? value : [];
  const [opts, setOpts] = useState([]);
  const [txt, setTxt] = useState("");

  useEffect(() => {
    api.get(`/options/${optionKey}`).then((r) => setOpts(r.data.values));
  }, [optionKey]);

  const add = async () => {
    const v = txt.trim();
    if (!v) return;
    const existing = opts.find((o) => o.toLowerCase() === v.toLowerCase()) || v;
    if (!tags.includes(existing)) onChange([...tags, existing]);
    if (!opts.includes(existing)) {
      try { const { data } = await api.post(`/options/${optionKey}`, { value: existing }); setOpts(data.values); } catch { /* sola lettura */ }
    }
    setTxt("");
  };

  return (
    <div className="mt-1" data-testid={testid}>
      <div className="flex gap-2">
        <Input list={`dl-${optionKey}`} value={txt} placeholder="Scegli o scrivi e premi Invio"
          onChange={(e) => setTxt(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          data-testid={`${testid}-input`} />
        <Button type="button" variant="outline" size="icon" onClick={add} data-testid={`${testid}-add`}><Plus className="h-4 w-4" /></Button>
        <datalist id={`dl-${optionKey}`}>{opts.filter((o) => !tags.includes(o)).map((o) => <option key={o} value={o} />)}</datalist>
      </div>
      {tags.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          {tags.map((t) => (
            <span key={t} className="inline-flex items-center gap-1 rounded-full border border-rose-200 bg-rose-50 px-2.5 py-0.5 text-xs font-medium text-rose-700" data-testid="tag-chip">
              {t}
              <button type="button" onClick={() => onChange(tags.filter((x) => x !== t))} className="hover:text-rose-900" data-testid={`tag-remove-${t}`}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
